/**
 * mtc-backoffice-api
 * MTC Backoffice Composite Api
 *
 * OpenAPI spec version: 0.1.0-SNAPSHOT
 * Contact: developers@greysystems.eu
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface CustomerBasicData { 
    address?: string;
    birthCity?: number;
    birthCountry?: string;
    birthDate?: string;
    city?: number;
    code?: string;
    codeExternal?: string;
    country?: string;
    countryNationality?: string;
    creationDate?: Date;
    email?: string;
    firstName?: string;
    id?: number;
    lastName?: string;
    mobile?: string;
    occupation?: string;
    pep?: boolean;
    postalCode?: string;
    sex?: CustomerBasicData.SexEnum;
    status?: CustomerBasicData.StatusEnum;
    telephone?: string;
    watched?: CustomerBasicData.WatchedEnum;
}
export namespace CustomerBasicData {
    export type SexEnum = 'Male' | 'Female';
    export const SexEnum = {
        Male: 'Male' as SexEnum,
        Female: 'Female' as SexEnum
    };
    export type StatusEnum = 'Active' | 'Unactive' | 'Blocked' | 'Unblocked';
    export const StatusEnum = {
        Active: 'Active' as StatusEnum,
        Unactive: 'Unactive' as StatusEnum,
        Blocked: 'Blocked' as StatusEnum,
        Unblocked: 'Unblocked' as StatusEnum
    };
    export type WatchedEnum = 'Watched' | 'Unwatched';
    export const WatchedEnum = {
        Watched: 'Watched' as WatchedEnum,
        Unwatched: 'Unwatched' as WatchedEnum
    };
}
